import styled from "styled-components";
import { Card, Tag, Progress } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { CustomButton } from "../../physician_page/styled";
import { MdMoreVert } from "react-icons/md";

// Common Card Wrapper
export const JourneyCardWrapper = styled(Card)`
  border: 1px solid var(--border-color);
  border-radius: 12px;
  background-color: var(--primary-bg);
  transition: all 0.3s ease;
  height: 100%;

  &:hover {
    box-shadow: 0 4px 12px rgba(138, 62, 244, 0.1);
    border-color: rgba(138, 62, 244, 0.3);
  }

  .ant-card-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .ant-avatar-group .ant-avatar {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    background-color: var(--border-color);
    color: var(--primary-text-color);
    cursor: pointer;
  }
  .ant-dropdown {
    z-index: 10;
  }
`;

// Card Header Components
export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const HeaderContent = styled.div`
  flex: 1;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

// Card Content
export const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: var(--primary-text-color);
  margin: 0 0 7px 0;
  line-height: 1.4;
  display: flex;
  align-items: center;
  gap: 8px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardDescription = styled.p`
  font-size: 14px;
  color: var(--secondary-text-color);
  margin: 0 0 16px 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Status Tag (with active/completed classes for Clinical Journeys)
export const StatusTag = styled(Tag)`
  border-radius: 12px;
  padding: 0px 10px;
  font-size: 13px;
  font-weight: 700;
  margin: 0;
  text-transform: capitalize;

  /* Default (Fall back or base) */
  color: #2F4EB6;
  border: 1px solid #C0DBFE;
  background-color: #DBE9FE;

  &.active {
    color: #2F4EB6;
    border: 1px solid #C0DBFE;
    background-color: #DBE9FE;
  }

  &.completed {
    background-color: #dcfce7;
    color: #166534;
    border: 1px solid #bbf7d0;
  }

  &.draft {
    background-color: #f3f4f6;
    color: #374151;
    border: 1px solid #d1d5db;
  }
`;

// Progress Components
export const ProgressContainer = styled.div`
  margin: 16px 0;
`;

export const ProgressHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--secondary-text-color);
  font-weight: 500;
`;

export const ProgressText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--secondary-text-color);
  font-weight: 500;
`;

export const StyledProgress = styled(Progress)`
  .ant-progress-bg {
    height: 12px !important;
    background-color: #8a3ef4 !important;
  }

  .ant-progress-inner {
    background-color: var(--border-color) !important;
  }
`;

// Date Info Components
export const DateInfo = styled.div`
  font-size: 14px;
  color: var(--secondary-text-color);
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const DateItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const DateSeparator = styled.span`
  color: var(--secondary-text-color);
  font-size: 12px;
`;

// Card Actions
export const CardActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
  flex-wrap: wrap;
`;

export const PreviewButton = styled(CustomButton)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  padding: 8px 16px;
`;

// Menu Icon
export const MenuIcon = styled(MdMoreVert)`
  font-size: 30px;
  color: var(--secondary-text-color);
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background-color: var(--secondary-bg);
    color: var(--primary-text-color);
  }
`;

// Empty State Components
export const EmptyStateCard = styled.div`
  background: var(--border-color);
  text-align: center;
  padding: 48px 24px;
  border-radius: 12px;
`;

export const EmptyStateText = styled.p`
  font-size: 26px;
  color: var(--secondary-text-color);
  margin: 0;
  font-weight: 700;
`;

export const CustomCheckBox = styled.div`
  position: absolute;
  top: 4px;
  left: 6px;
`;

